import useFetch from 'elements/Hooks/useFetch'
import React from 'react'
import Vouchers from '../../../components/Purchasing/Voucher/Vouchers'
import List from '../../../components/Purchasing/Voucher/VouchersList'
import useListCompanyFilter from '../../../elements/Hooks/useListCompanyFilter'
import useTitle from '../../../elements/Hooks/useTitle'

export default function VouchersCont({ order }) {
  const select =
    '_key,_id,_rev,code,no,billDate,date,dueDate,payee,type,orders,title,center,contract,' +
    'company,bank,currency,scheduledDate,paymentPlan,paymentStatus,paid,subTotal,amount,status'

  const url = !!order ? `vouchers?select=${select}&order=${order._key}` : `vouchers?select=${select}`
  const { data, fetching, fetch } = useFetch({ url })

  const { list, company, onChangeCompany } = useListCompanyFilter(data, fetching)

  const { data: cachedLines, fetching: fetchingLines, fetch: fetchLines } = useFetch({
    url: `vouchers/lines`,
  })
  const { list: listLines, company: companyLines, onChangeCompany: onChangeCompanyLines } = useListCompanyFilter(
    cachedLines,
    fetchingLines
  )

  console.log({ cachedLines })

  useTitle('Vouchers')

  const sharedProps = {
    list,
    fetching,
    fetch,
    company,
    onChangeCompany,

    fetchingLines,
    fetchLines,
    listLines,
    companyLines,
    onChangeCompanyLines,
  }

  return !!order ? <List {...sharedProps} /> : <Vouchers {...sharedProps} />
}
